import { render } from "./DetailsAdvertising.vue?vue&type=template&id=0ee5e541&scoped=true"
import script from "./DetailsAdvertising.vue?vue&type=script&lang=js"
export * from "./DetailsAdvertising.vue?vue&type=script&lang=js"

import "./DetailsAdvertising.vue?vue&type=style&index=0&id=0ee5e541&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ee5e541"]])

export default __exports__